import BarChartIcon from '@mui/icons-material/BarChart';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import WorkIcon from '@mui/icons-material/Work';
import PregnantWomanIcon from '@mui/icons-material/PregnantWoman';

export const menus = [
    {
        title: 'Resultados',
        icon: <BarChartIcon className="menu-icon-sidebar-dashboards" fontSize="large" />,
        path: '/governanceroom/dashboardesus/general-results',
        gap: true
    },
    {
        title: 'Cadastros',
        icon: <AssignmentIndIcon className="menu-icon-sidebar-dashboards" fontSize="large" />,
        path: '/governanceroom/dashboardesus/registers',
    },
    {
        title: 'Produção',
        icon: <WorkIcon className="menu-icon-sidebar-dashboards" fontSize="large" />,
        path: '/governanceroom/dashboardesus/production',
    },
    {
        title: 'SIM/SINASC',
        icon: <PregnantWomanIcon className="menu-icon-sidebar-dashboards" fontSize="large" />,
        path: '/governanceroom/dashboardesus/sim-sinasc',
    },
];